import React from 'react'

const AddCounselling = () => {
  return (
    <div>AddCounselling</div>
  )
}

export default AddCounselling